export default [4, 53, 10, 10, 12, 11];